import { AWS_BUCKET_URL } from '../toolkit/constants';

const configs = {
  game90: {
    id: 'game90',
    title: 'Game90',
    logo: AWS_BUCKET_URL + '/brand/game90.png',
    favicon: AWS_BUCKET_URL + '/brand/game90-favicon.ico',
    imageDimension: {
      width: 163,
      height: 34
    },
    manifest: {
      short_name: 'Game90',
      name: 'Game 90 Betting Website',
      theme_color: '#af021f',
      background_color: '#ffffff',
      icons: [
        {
          src: AWS_BUCKET_URL + '/brand/game90-favicon.ico',
          sizes: '64x64 32x32 24x24 16x16',
          type: 'image/x-icon'
        },
        {
          src: AWS_BUCKET_URL + '/brand/game90-favicon-32x32.png',
          type: 'image/png',
          sizes: '32x32'
        },
        {
          src: AWS_BUCKET_URL + '/brand/game90-favicon-16x16.png',
          type: 'image/png',
          sizes: '16x16'
        }
      ]
    }
  },
  live247: {
    id: 'live247',
    title: 'Live247',
    logo: AWS_BUCKET_URL + '/brand/live247.png',
    favicon: AWS_BUCKET_URL + '/brand/live247-favicon.ico',
    imageDimension: {
      width: 101,
      height: 38
    },
    manifest: {
      short_name: 'Live247',
      name: 'Live 24/7 Betting Website',
      theme_color: '#3159a8',
      background_color: '#ffffff',
      icons: [
        {
          src: AWS_BUCKET_URL + '/brand/live247-favicon.ico',
          sizes: '64x64 32x32 24x24 16x16',
          type: 'image/x-icon'
        },
        {
          src: AWS_BUCKET_URL + '/brand/live247-favicon-32x32.png',
          type: 'image/png',
          sizes: '32x32'
        },
        {
          src: AWS_BUCKET_URL + '/brand/live247-favicon-16x16.png',
          type: 'image/png',
          sizes: '16x16'
        }
      ]
    }
  }
};

export const getConfig = () => {
  if (typeof window === 'undefined') {
    return;
  }
  const host = window.location.host;
  if (host.includes('game90.bet')) {
    return configs.game90;
  } else if (host.includes('palubet.com')) {
    return configs.live247;
  } else if (host.includes('live247.bet')) {
    return configs.live247;
  }
  return configs.game90;
};

const setConfig = () => {
  const config = getConfig();
  if (typeof document === 'undefined') {
    return;
  }
  document.title = config.title;
  document.documentElement.setAttribute('data-app', config.id);
  document.querySelector('link[rel="icon"]').href = config.favicon;

  // Update manifest dynamically
  updateManifest(config);
};

const updateManifest = (config) => {
  if (typeof document === 'undefined') {
    return;
  }

  // Update theme-color meta tag
  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta) {
    themeColorMeta.setAttribute('content', config.manifest.theme_color);
  } else {
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = config.manifest.theme_color;
    document.head.appendChild(meta);
  }

  // Update Apple touch icon for Safari PWA
  updateAppleTouchIcon(config);

  // Update manifest link
  const manifestLink = document.querySelector('link[rel="manifest"]');
  if (manifestLink) {
    // Create dynamic manifest content
    const manifestContent = {
      ...config.manifest,
      start_url: window.location.origin + '/',
      display: 'standalone'
    };

    // Create blob URL for dynamic manifest
    const blob = new Blob([JSON.stringify(manifestContent, null, 2)], {
      type: 'application/json'
    });
    const manifestUrl = URL.createObjectURL(blob);
    manifestLink.href = manifestUrl;
  }
};

const updateAppleTouchIcon = (config) => {
  if (typeof document === 'undefined') {
    return;
  }

  // Remove existing apple-touch-icon links
  const existingIcons = document.querySelectorAll('link[rel="apple-touch-icon"]');
  existingIcons.forEach((icon) => icon.remove());

  // Add new apple-touch-icon for Safari PWA
  const appleTouchIcon = document.createElement('link');
  appleTouchIcon.rel = 'apple-touch-icon';
  appleTouchIcon.href = config.manifest.icons[0].src; // Use the first icon
  document.head.appendChild(appleTouchIcon);

  // Add apple-touch-icon with sizes for better compatibility
  const appleTouchIconSizes = document.createElement('link');
  appleTouchIconSizes.rel = 'apple-touch-icon';
  appleTouchIconSizes.sizes = '180x180';
  appleTouchIconSizes.href = config.manifest.icons[0].src;
  document.head.appendChild(appleTouchIconSizes);
};

setConfig();
